import axiosInstance from '../axios_instance';
import {
  ClientEngagedTypeList,
  SkillCategoryList,
  SkillTypeList,
  StatusTypeList,
} from '../utils/object';
import { SearchTypeMapping } from '../utils/option-list/helper';

function buildDropdownOptions(
  setDropdownOption: any,
  dropdownSearchCriteriaList: Array<{ value: string; label: string }>
) {
  dropdownSearchCriteriaList.map((item: { value: string; label: string }) => {
    if (item.value === 'skill-id') {
      axiosInstance.get('/api/v1/skills').then((response) => {
        const skills = response.data.skills.reduce(
          (initialList: Array<any>, CurrentList: { [key: string]: any }) => [
            ...initialList,
            { [CurrentList.skill_name]: CurrentList.skill_id },
          ],
          []
        );
        setDropdownOption((prev: any) => {
          return { ...prev, [item['value']]: skills };
        });
      });
    } else if (item.value === 'skill-category list') {
      axiosInstance
        .get('/api/v1/skills/categories')
        .then((response) => {
          const categories = response.data.map((cat: any) => ({
            [cat.name]: cat.id,
          }));
          setDropdownOption((prev: any) => {
            return { ...prev, [item['value']]: categories };
          });
        })
        .catch((error) => {
          console.error('Failed to fetch skill categories', error);
        });
    } else if (item.value === 'skill_types') {
      setDropdownOption((prev: any) => {
        return { ...prev, [item['value']]: SkillTypeList };
      });
    } else if (item.value === 'resource_engaged') {
      setDropdownOption((prev: any) => {
        return { ...prev, [item['value']]: ClientEngagedTypeList };
      });
    } else if (item.value === 'profile_status') {
      setDropdownOption((prev: any) => {
        return { ...prev, [item['value']]: StatusTypeList };
      });
    }
  });
}

export const getDropdownOptions = (
  searchCriteriaList: Array<{ value: string; label: string }>,
  setDropdownOption: any
) => {
  const dropdownSearchCriteriaList = searchCriteriaList.filter((item: any) => {
    return SearchTypeMapping[item.value] === 'dropdown';
  });
  buildDropdownOptions(setDropdownOption, dropdownSearchCriteriaList);
};
